const riders = [
  {
    id: 1,
    productId: 2,
    planCodes: ['1_2_NM_vQUcrR'],
    name: "Children's Term to 25 Rider",
    type: 'CR',
    description:
      "Upon proof of the insured child's death, policy will pay beneficiary up to $10,000, subject to policy provisions. Issue Age 30 days - 23: $10,000 Face Amount for $2.00 per week.",
    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      }
    },
    additional: 'per eligible child',
    coverages: [
      {
        Id: 0,
        FaceAmount: '10000',
        PremiumPerWeek: '2'
      }
    ]
  },

  {
    id: 2,
    productId: 2,
    description:
      'This rider pays up to $32,000 for an Accidental Death, subject to policy provisions. This benefit pays in addition to other sums collected under the policy (on standard policy only). Employee and Spouse Issue Age 18-55: $16,000 Face Amount for $0.50 per week; $32,000 Face Amount for $1.00 per week.',
    planCodes: ['1_2_NM_vQUcrR'],
    name: 'Accidental Death Benefit Rider',
    type: 'ADB',

    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },

    coverages: [
      {
        Id: 0,
        FaceAmount: '16000',
        PremiumPerWeek: '0.5',
        units: 1
      },
      {
        Id: 1,
        FaceAmount: '32000',
        PremiumPerWeek: '1',
        units: 2
      }
    ]
  },

  {
    id: 3,
    productId: 2,
    planCodes: ['1_2_NM_vQUcrR'],
    name: 'Waiver of Premium Disability Rider*',
    description:
      "Upon proof of the insured's total disability as defined by this rider, the company will waive any premiums due (on standard policy only). Issue Age 15-55: No additional charge for this rider.",
    included: 'Included',
    type: 'WP',
    eligibility: {
      employee: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      child: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 4,
    productId: 2,
    planCodes: ['1_2_NM_vQUcrR'],
    name: 'Terminal Illness Accelerated Benefit Rider*',
    description:
      'Upon proof of terminal illness, insured will receive 50% of the current benefit available prior to death, subject to provisions of the rider (on standard policy only). No additional charge for this rider.',
    templateId: 6,
    included: 'Included',
    type: 'TI',
    eligibility: {
      employee: {
        condition: 'always'
      },
      spouse: {
        condition: 'always'
      },
      child: {
        condition: 'always'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 5,
    productId: 2,
    planCodes: ['1_2_NM_vQUcrR'],
    name: 'Deposit Fund Rider',
    description:
      'This rider is available with new life insurance polices that are on Allotment or Bank Draft. Deposits can be made regularly with premium payments to create an interest bearing account that can be used for any purpose. The guaranteed minimum interest rate will be 3% for all years the rider is in force. Withdrawals made available 30 days following initial deposit. There is no penalty or charge for withdrawals. Account balance can never exceed the current face amount to which the rider is attached. Special State Restrictions Apply',
    templateId: 7,
    type: 'DFR',
    eligibility: {
      employee: {
        condition: 'allowed'
      },
      spouse: {
        condition: 'allowed'
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'sameRider']
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'sameRider']
      },
      child: {
        condition: 'na'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },
  {
    id: 6,
    productId: 3,
    planCodes: ['4_3_NM_8kS262'],
    name: "Children's Term to 25 Rider",
    type: 'CR',
    description:
      "Upon proof of the insured child's death, policy will pay beneficiary up to $10,000, subject to policy provisions. Issue Age 30 days - 23: $10,000 Face Amount for $2.00 per week.",
    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      }
    },
    additional: 'per eligible child',
    coverages: [
      {
        Id: 0,
        FaceAmount: '10000',
        PremiumPerWeek: '2'
      }
    ]
  },

  {
    id: 7,
    description:
      'This rider pays up to $32,000 for an Accidental Death, subject to policy provisions. This benefit pays in addition to other sums collected under the policy (on standard policy only). Employee and Spouse Issue Age 18-55: $16,000 Face Amount for $0.50 per week; $32,000 Face Amount for $1.00 per week.',
    productId: 3,
    planCodes: ['4_3_NM_8kS262'],
    name: 'Accidental Death Benefit Rider',
    type: 'ADB',

    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },

    coverages: [
      {
        Id: 0,
        FaceAmount: '16000',
        PremiumPerWeek: '0.5',
        units: 1
      },
      {
        Id: 1,
        FaceAmount: '32000',
        PremiumPerWeek: '1',
        units: 2
      }
    ]
  },

  {
    id: 8,
    productId: 3,
    planCodes: ['4_3_NM_8kS262'],
    name: 'Waiver of Premium Disability Rider*',
    description:
      "Upon proof of the insured's total disability as defined by this rider, the company will waive any premiums due (on standard policy only). Issue Age 15-55: No additional charge for this rider.",
    included: 'Included',
    type: 'WP',
    eligibility: {
      employee: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      child: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 9,
    productId: 3,
    planCodes: ['4_3_NM_8kS262'],
    name: 'Terminal Illness Accelerated Benefit Rider*',
    description:
      'Upon proof of terminal illness, insured will receive 50% of the current benefit available prior to death, subject to provisions of the rider (on standard policy only). No additional charge for this rider.',
    templateId: 6,
    included: 'Included',
    type: 'TI',
    eligibility: {
      employee: {
        condition: 'always'
      },
      spouse: {
        condition: 'always'
      },
      child: {
        condition: 'always'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 10,
    productId: 3,
    planCodes: ['4_3_NM_8kS262'],
    name: 'Deposit Fund Rider',
    description:
      'This rider is available with new life insurance polices that are on Allotment or Bank Draft. Deposits can be made regularly with premium payments to create an interest bearing account that can be used for any purpose. The guaranteed minimum interest rate will be 3% for all years the rider is in force. Withdrawals made available 30 days following initial deposit. There is no penalty or charge for withdrawals. Account balance can never exceed the current face amount to which the rider is attached. Special State Restrictions Apply',
    templateId: 7,
    type: 'DFR',
    eligibility: {
      employee: {
        condition: 'allowed'
      },
      spouse: {
        condition: 'allowed'
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'sameRider']
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'sameRider']
      },
      child: {
        condition: 'na'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 11,
    productId: 2,
    planCodes: ['1_2_NM_9ohhZe'],
    name: "Children's Term to 25 Rider",
    type: 'CR',
    description:
      "Upon proof of the insured child's death, policy will pay beneficiary up to $10,000, subject to policy provisions. Issue Age 30 days - 23: $10,000 Face Amount for $2.00 per week.",
    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      }
    },
    additional: 'per eligible child',
    coverages: [
      {
        Id: 0,
        FaceAmount: '10000',
        PremiumPerWeek: '2'
      }
    ]
  },

  {
    id: 12,
    productId: 2,
    description:
      'This rider pays up to $32,000 for an Accidental Death, subject to policy provisions. This benefit pays in addition to other sums collected under the policy (on standard policy only). Employee and Spouse Issue Age 18-55: $16,000 Face Amount for $0.50 per week; $32,000 Face Amount for $1.00 per week.',
    planCodes: ['1_2_NM_9ohhZe'],
    name: 'Accidental Death Benefit Rider',
    type: 'ADB',

    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },

    coverages: [
      {
        Id: 0,
        FaceAmount: '16000',
        PremiumPerWeek: '0.5',
        units: 1
      },
      {
        Id: 1,
        FaceAmount: '32000',
        PremiumPerWeek: '1',
        units: 2
      }
    ]
  },

  {
    id: 13,
    productId: 2,
    planCodes: ['1_2_NM_9ohhZe'],
    name: 'Waiver of Premium Disability Rider*',
    description:
      "Upon proof of the insured's total disability as defined by this rider, the company will waive any premiums due (on standard policy only). Issue Age 15-55: No additional charge for this rider.",
    included: 'Included',
    type: 'WP',
    eligibility: {
      employee: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      child: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 14,
    productId: 2,
    planCodes: ['1_2_NM_9ohhZe'],
    name: 'Terminal Illness Accelerated Benefit Rider*',
    description:
      'Upon proof of terminal illness, insured will receive 50% of the current benefit available prior to death, subject to provisions of the rider (on standard policy only). No additional charge for this rider.',
    templateId: 6,
    included: 'Included',
    type: 'TI',
    eligibility: {
      employee: {
        condition: 'always'
      },
      spouse: {
        condition: 'always'
      },
      child: {
        condition: 'always'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 15,
    productId: 2,
    planCodes: ['1_2_NM_9ohhZe'],
    name: 'Deposit Fund Rider',
    description:
      'This rider is available with new life insurance polices that are on Allotment or Bank Draft. Deposits can be made regularly with premium payments to create an interest bearing account that can be used for any purpose. The guaranteed minimum interest rate will be 3% for all years the rider is in force. Withdrawals made available 30 days following initial deposit. There is no penalty or charge for withdrawals. Account balance can never exceed the current face amount to which the rider is attached. Special State Restrictions Apply',
    templateId: 7,
    type: 'DFR',
    eligibility: {
      employee: {
        condition: 'allowed'
      },
      spouse: {
        condition: 'allowed'
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'sameRider']
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'sameRider']
      },
      child: {
        condition: 'na'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },
  {
    id: 16,
    productId: 3,
    planCodes: ['4_3_NM_8kS263'],
    name: "Children's Term to 25 Rider",
    type: 'CR',
    description:
      "Upon proof of the insured child's death, policy will pay beneficiary up to $10,000, subject to policy provisions. Issue Age 30 days - 23: $10,000 Face Amount for $2.00 per week.",
    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'age_child', 'sameRider'],
        age_child: {
          minAgeDays: 30,
          maxAgeYears: 23
        }
      }
    },
    additional: 'per eligible child',
    coverages: [
      {
        Id: 0,
        FaceAmount: '10000',
        PremiumPerWeek: '2'
      }
    ]
  },

  {
    id: 17,
    description:
      'This rider pays up to $32,000 for an Accidental Death, subject to policy provisions. This benefit pays in addition to other sums collected under the policy (on standard policy only). Employee and Spouse Issue Age 18-55: $16,000 Face Amount for $0.50 per week; $32,000 Face Amount for $1.00 per week.',
    productId: 3,
    planCodes: ['4_3_NM_8kS263'],
    name: 'Accidental Death Benefit Rider',
    type: 'ADB',

    eligibility: {
      employee: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'age',
        minAgeYears: 18,
        maxAgeYears: 55
      },
      child: {
        condition: 'na'
      }
    },

    coverages: [
      {
        Id: 0,
        FaceAmount: '16000',
        PremiumPerWeek: '0.5',
        units: 1
      },
      {
        Id: 1,
        FaceAmount: '32000',
        PremiumPerWeek: '1',
        units: 2
      }
    ]
  },

  {
    id: 18,
    productId: 3,
    planCodes: ['4_3_NM_8kS263'],
    name: 'Waiver of Premium Disability Rider*',
    description:
      "Upon proof of the insured's total disability as defined by this rider, the company will waive any premiums due (on standard policy only). Issue Age 15-55: No additional charge for this rider.",
    included: 'Included',
    type: 'WP',
    eligibility: {
      employee: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      spouse: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      },
      child: {
        condition: 'always|age',
        minAgeYears: 15,
        maxAgeYears: 55
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 19,
    productId: 3,
    planCodes: ['4_3_NM_8kS263'],
    name: 'Terminal Illness Accelerated Benefit Rider*',
    description:
      'Upon proof of terminal illness, insured will receive 50% of the current benefit available prior to death, subject to provisions of the rider (on standard policy only). No additional charge for this rider.',
    templateId: 6,
    included: 'Included',
    type: 'TI',
    eligibility: {
      employee: {
        condition: 'always'
      },
      spouse: {
        condition: 'always'
      },
      child: {
        condition: 'always'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  },

  {
    id: 20,
    productId: 3,
    planCodes: ['4_3_NM_8kS263'],
    name: 'Deposit Fund Rider',
    description:
      'This rider is available with new life insurance polices that are on Allotment or Bank Draft. Deposits can be made regularly with premium payments to create an interest bearing account that can be used for any purpose. The guaranteed minimum interest rate will be 3% for all years the rider is in force. Withdrawals made available 30 days following initial deposit. There is no penalty or charge for withdrawals. Account balance can never exceed the current face amount to which the rider is attached. Special State Restrictions Apply',
    templateId: 7,
    type: 'DFR',
    eligibility: {
      employee: {
        condition: 'allowed'
      },
      spouse: {
        condition: 'allowed'
      },
      child: {
        condition: 'na'
      }
    },
    requirements: {
      employee: {
        condition: 'exclude',
        excludedBy: ['spouse', 'sameRider']
      },
      spouse: {
        condition: 'exclude',
        excludedBy: ['employee', 'applicant', 'sameRider']
      },
      child: {
        condition: 'na'
      }
    },
    coverages: [
      {
        Id: 0,
        FaceAmount: '0',
        PremiumPerWeek: '0'
      }
    ]
  }
]

export default riders
